export default __webpack_public_path__ + "static/media/vf9.ab5908d8.jpg";